<span>
    <mat-form-field class="filter" preventFocus>
        <mat-label class="filter"> {{ 'WIDGETS.BOARDS' | translate }}:</mat-label>
        <input [formControl]="textFilterInput" matInput>
    </mat-form-field>
    <span (click)="changeSettings(dash.alias, widget)" cdkFocusInitial
          *ngFor="let dash of dashes"
          [class]="(widget.options_dict?.boards|| widget.options_dict.task_board)?.includes(dash.alias)||widget.options_dict.alias === dash.alias ? 'text-bg-info' : 'text-bg-light'"
          class="badge badge-pill m-1"
          style="cursor: pointer; font-size: medium;"
    >
      {{ dash.alias }}
    </span>
    <div>
    <b class="block-header">{{ 'WIDGETS.TASK_TYPES' | translate }}:</b><br>
    <p *ngFor="let board of widget?.content?.dashes"
       [class.d-none]="!widget.options_dict.task_board?.includes(board.alias)"
    >
        <span>{{ board.alias }}</span>
        <span (click)="changeSettings(type.id, widget,'task_type')"
              *ngFor="let type of board.task_types"
              [class]="widget.options_dict.task_type?.includes(type.id) ? 'text-bg-info' : 'text-bg-light'"
              class="badge badge-pill m-1"
              style="cursor: pointer; font-size: medium;"
        >
            <i [class]="type.icon"></i>  {{ type.name }}
        </span>
    </p>
</div>
</span>